import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import NavbarContext from '../../navbar/context'
import {
  setBackPathname,
  setClosePathname,
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import { Box } from '@material-ui/core'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import { fetchStatusIs, RequestStatus } from '../../../api/types'
import paymentApi from '../../../api/services/PaymentApi'
import {
  AutorizeTransactionData,
  PaymentGatewayData,
  PaymentRequestData,
} from '../../../api/services/types'
import AppSpinner from '../../../components/AppSpinner'
import FormSubmitter from '../../../components/form-submitter/FormSubmitter'
import CreditCardIcon from '../../../shared/icons/credit_card_icon'
import buildStyles from './styles'

export type ConfirmTransactionParamsType = {
  locationCode: string
  organizationId: string
  goalId: string
}

const ConfirmTransaction = () => {
  const { state } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const [fetchData, setFetchData] = useState<PaymentGatewayData | null>(null)

  const [paymentRequestData, setPaymentRequestData] =
    useState<PaymentRequestData | null>(null)

  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )

  const { idle, pending, fulfilled } = fetchStatusIs(requestStatus)

  const { locationCode, organizationId, goalId } =
    useParams<ConfirmTransactionParamsType>()

  const navigate = useNavigate()

  useEffect(() => {
    setBackPathname(
      navbarContextDispatch,
      state.rules.length > 0
        ? `/${locationCode}/${organizationId}/${goalId}/regulamin`
        : `/${locationCode}/${organizationId}/${goalId}/kwota`
    )
    setClosePathname(navbarContextDispatch, `/${locationCode}`)
    setIsBackButtonVisible(navbarContextDispatch, true)
    setIsCloseButtonVisible(navbarContextDispatch, true)
  }, [
    locationCode,
    organizationId,
    goalId,
    navbarContextDispatch,
    state.rules.length,
  ])

  const fetch = useCallback(async () => {
    if (!state.amount) return

    setRequestStatus(RequestStatus.Pending)

    const data: AutorizeTransactionData = {
      email: 'ala@gmail.com',
      name: 'ala',
      lastName: 'nowak',
      amount: Number(state.amount.value) * 100,
      goalId: Number(goalId),
      locationCode: locationCode ?? '',
    }
    const result = await paymentApi.autorizeTransaction(data)

    if (result) {
      setFetchData(result.data)
      setRequestStatus(RequestStatus.Fulfilled)
    } else {
      setRequestStatus(RequestStatus.Rejected)
    }
  }, [goalId, locationCode, state.amount])

  useEffect(() => {
    if (idle) {
      fetch()
    }
  }, [idle, fetch])

  if (!state.selectedOrganization || !state.selectedGoal) {
    navigate('/blad')
    return null
  }

  const handleRedirectToPayment = () => {
    if (fetchData) setPaymentRequestData(fetchData.requestData)
  }

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <>
      <MainLayout withSideImage withNavbar>
        <>
          <AppSpinner show={pending} />
          <HeaderInfo
            title="Potwierdzenie wpłaty"
            arrowedTitle={state.selectedGoal.title}
            orgName={state.selectedOrganization.name}
            altText={state.amount?.txt}
            addedSmallPadding={true}
          />

          {fulfilled && (
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              paddingTop="50px"
              justifyContent="center"
              alignItems="center"
              className={styles.container}
            >
              <CreditCardIcon className={styles.creditCardIcon} />
              <div
                className={styles.nextButton}
                onClick={() => {
                  handleRedirectToPayment()
                }}
              >
                <span className={styles.nextButtonSpan}>ZAPŁAĆ</span>
              </div>
            </Box>
          )}
        </>
      </MainLayout>

      {paymentRequestData && (
        <FormSubmitter<PaymentRequestData>
          url={fetchData?.redirectUrl}
          formData={paymentRequestData}
        />
      )}
    </>
  )
}

export default ConfirmTransaction
